module.exports = __webpack_public_path__ + "img/medium-workmark.361137c5.svg";